import * as React from "react";

const Diary = () => {
  return (
    <>
      <div className="mainContainer">
        <button>다이어리</button>
      </div>
    </>
  )
}

export default Diary;